import { render } from "./UploadRoutesFile.vue?vue&type=template&id=15c85fd8&scoped=true"
import script from "./UploadRoutesFile.vue?vue&type=script&lang=js"
export * from "./UploadRoutesFile.vue?vue&type=script&lang=js"

import "./UploadRoutesFile.vue?vue&type=style&index=0&id=15c85fd8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c85fd8"]])

export default __exports__